// Guards for removing an animal from a sale (visit).
// The server (backend/lib/validation/saleValidator.js) rejects any sale save
// where a journal's animal is no longer among the sale's animals. If the
// client removes such an animal locally anyway, every later save of the visit
// fails until the page is reloaded — so removal must be blocked client-side
// with a clear message while the animal still has a journal in the visit.

// Animals embedded in a sale come in two shapes: fresh DHP picks carry
// opprinnelsesmerke/oremerke, stored animal records carry markOfOrigin/earMark.
function findSaleAnimalByTag(animals, markOfOrigin, earMark) {
    if (!Array.isArray(animals)) {
        return undefined;
    }
    return animals.find(a => a && ((a.opprinnelsesmerke === markOfOrigin && a.oremerke === earMark)
        || (a.markOfOrigin === markOfOrigin && a.earMark === earMark)));
}

function animalHasJournalInSale(journals, animalId) {
    if (!Array.isArray(journals) || !animalId) {
        return false;
    }
    const id = parseInt(animalId, 10);
    return journals.some(j => j && parseInt(j.animal, 10) === id);
}

// TICKET-01450: a sale that already carries the same animal id twice (older
// builds could append duplicate entries) must never render as two independent
// treatment lines — the rows resolve their journals by animal id, so both
// "lines" are the SAME journal and writing in one visibly rewrites the other.
// Keeps the FIRST entry per id (the one every findIndex-based edit handler
// targets); entries without a usable id are all kept. Returns a NEW array —
// the shared newSale.animals observable is never mutated.
function dedupeSaleAnimalsById(animals) {
    if (!Array.isArray(animals)) {
        return [];
    }
    const seen = new Set();
    return animals.filter(a => {
        const id = parseInt(a?.id, 10);
        if (!(id > 0)) {
            return true;
        }
        if (seen.has(id)) {
            return false;
        }
        seen.add(id);
        return true;
    });
}

export {
    findSaleAnimalByTag,
    animalHasJournalInSale,
    dedupeSaleAnimalsById,
};
